<template>
  <div class="pa-10">
    <title-page icon="mdi-domain">{{ isEdit ? $t('organization.perimeter.edit') : $t('organization.perimeter.add') }}</title-page>
    <v-form ref="form" @submit.prevent="save">
      <v-row>
        <v-col cols="12" md="6">
          <form-field :label="$t('code')" v-model="form.code" :rules="[commonRules.required]" />
          <form-field :label="$t('name')" type="localized-string" v-model="form.name" :rules="[commonRules.required]" />
        </v-col>
      </v-row>
      <v-row class="mt-6">
        <v-col class="text-center">
          <v-btn type="submit" color="primary">{{ $t('save') }}</v-btn>
          <v-btn class="ml-2" @click="cancel">{{ $t('cancel') }}</v-btn>
          </v-col>
      </v-row>
      <v-row class="mt-12">
        <v-col class="text-center">
          <v-btn small outlined color="red" v-if="isEdit" class="ml-2" @click="deleteItem">{{ $t('delete') }}</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import RulesMixin from "@mixins/RulesMixin";
import OrganizationPerimeterRepository from "@repository/OrganizationPerimeterRepository";

export default {
  data() {
    return {
      form: {
        code: null,
        name: null,
      }
    }
  },
  mixins: [RulesMixin],
  computed: {
    id() {
      return this.$route.params.id || null
    },
    isEdit() { return !!this.id }
  },
  mounted() {
    if (this.isEdit) {
      this.showLoading(true)
      OrganizationPerimeterRepository.getPerimeter(this.id).then(result => {
        this.form = {
          code: result.code || null,
          name: result.name || null,
        }
        this.$nextTick(() => this.cleanUnsavedChanges())
        this.showLoading(false)
      }).catch(err => {
        this.showLoading(false)
        this.notifyError(err)
      })
    }
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'organization-perimeter' })
    },
    save() {
      if (!this.$refs.form.validate()) return
      this.showLoading(true)
      const payload = { ...this.form }
      if (this.isEdit) {
        OrganizationPerimeterRepository.updatePerimeter(this.id, payload)
          .then(() => {
            this.$dialog.notify.success(this.$t('update-success'))
            this.showLoading(false)
            this.$router.back()
          }).catch(err => {
            this.showLoading(false)
            this.notifyError(err)
          })
      } else {
        OrganizationPerimeterRepository.createPerimeter(payload)
          .then(() => {
            this.$dialog.notify.success(this.$t('created-successfully'))
            this.showLoading(false)
            this.$router.back()
          }).catch(err => {
            this.showLoading(false)
            this.notifyError(err)
          })
      }
    },
    deleteItem() {
      this.$dialog.confirm({text: this.$t('are-you-sure')}).then(result => {
        if (!result) return
        this.showLoading(true)
        OrganizationPerimeterRepository.deletePerimeter(this.id)
          .then(() => {
            this.$dialog.notify.success(this.$t('delete-success'))
            this.showLoading(false)
            this.$router.back()
          }).catch(err => {
            this.showLoading(false)
            this.notifyError(err)
          })
      })
    }
  }
}
</script>
